// Definição para o modal de busca de Grupos de Acesso
// Factory function - recebe idOrganizacao como parâmetro para filtrar os grupos da organização ativa
// Utilizada no cadastro de Usuários para seleção de grupos de acesso

export const criarConfigBuscaGrupoAcesso = (idOrganizacao) => ({
  label: 'Grupo de Acesso',
  placeholder: 'Nome do Grupo...',
  titulo: 'Selecionar Grupos de Acesso',
  endpointApi: 'GruposAcesso',
  idField: 'idGrupoAcesso',
  displayField: 'idGrupoAcesso',
  descField: 'nome',

  camposFiltro: [
    { label: 'Nome do Grupo', model: 'busca', tipo: 'text' }
  ],

  colunasGrid: [
    { header: 'ID', dataField: 'idGrupoAcesso', width: '10%' },
    { header: 'Nome', dataField: 'nome', width: '45%' },
    { header: 'Descrição', dataField: 'descricao', width: '45%' }
  ],

  filtrosFixos: {
    idOrganizacao
  }
})
